export default __webpack_public_path__ + "static/media/world-atlas-2-rMIN.d5cdbb60.jpg";